const React = require('react');
const _ = require('./../../../lib/underscore');
const BoligSoknad = require('./forms/BoligSoknad');
const Faktura = require('./forms/Faktura');
const GarasjePlass = require('./forms/GarasjePlass');
const Bod = require('./forms/Bod');
const FeilOgMangler = require('./forms/FeilOgMangler');
const Oppsigelse = require('./forms/Oppsigelse');
const KopiAvLeie = require('./forms/KopiAvLeie');
const SoekNaering = require('./forms/SoekNaering');
const Other = require('./forms/Other');
const isNode = (typeof process !== 'undefined');
const Select = isNode ? require('react-select') : <div/>;
const axios = isNode && require('axios');
const Formsy = isNode ? require('formsy-react') : '<div/>';
const Input = require('./FormComponents/Input');

const forms = [
    { key: "boligsoknad", label: 'Boligsøknad', component: BoligSoknad },
    { key: "faktura", label: 'Kopi av faktura', component: Faktura },
    { key: "garasjeplass", label: "Garasjeplass", component: GarasjePlass },
    { key: "bod", label: "Søknad om bod", component: Bod },
    { key: "feil-og-mangler", label: "Feil og mangler", component: FeilOgMangler },
    { key: "oppsigelse", label: "Oppsigelse av leieforhold", component: Oppsigelse },
    { key: "kopi", label: "Kopi av leiekontrakt", component: KopiAvLeie },
    { key: "soek-naering", label: "Søk etter næringslokale", component: SoekNaering },
    { key: "andre-henvendelser", label: "Andre henvendelser", component: Other }
];

class Forms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: this.props.selectedForm || null,
            canSubmit: false,
            error: false,
            sent: false
        };
        this.childForm = null;
        this.getValues = this.getValues.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.onValid = this.onValid.bind(this);
        this.onInvalid = this.onInvalid.bind(this);
    }

    onValid() {
        this.setState({ canSubmit: true });
    }

    onInvalid() {
        this.setState({ canSubmit: false });
    }

    submitForm(formData) {
        this.setState({ error: false, sent: false });

        const { emailServiceUrl } = this.props;
        const { selected } = this.state;
        const selectedForm = forms.filter(form => {
            return form.key === selected
        }).shift();
        const data = _.extend(selectedForm, this.getValues(), formData);
        if (!data) return false;

        axios({
            method: 'post',
            url: emailServiceUrl,
            data: data
        }).then(res => {
            const { data } = res;
            if (data && data.mailSent && data.mailSent === true) {
                this.setState({ error: false, sent: true, selected: null });
                this.form.reset();
                window.location.href = this.props.formSubmitSuccessPageUrl;
            } else {
                this.setState({ error: true, sent: false });
            }
        }).catch(err => {
            this.setState({ error: true, sent: false });
        });

    }

    getValues() {
        const childValues = (this.childForm) ? this.childForm.getValues() : null;
        const formValues = _.extend(
            childValues
        );

        return formValues;
    }

    render() {
        const { selected } = this.state;
        const { hidePicker, hideHeaders, color, termsPageUrl, formSubmitSuccessPageUrl } = this.props;
        const { error } = this.state;
        return (
            <Formsy.Form
                method="post"
                ref={(form) => this.form = form}
                onValidSubmit={this.submitForm}
                onValid={this.onValid}
                onInvalid={this.onInvalid}
                validationErrors={this.state.validationErrors}
            >
                <div className={`forms__inputContainer forms__inputContainer--${color}`}>
                    {!hidePicker && (
                        <div className="forms__formSelector">
                            <h3>Hva gjelder din henvendelse?</h3>

                            <Select
                                value={selected}
                                onChange={(val) => {
                                    const selected = val ? val.value : null;
                                    this.setState({ selected: selected })
                                }}
                                options={forms.map(form => {
                                    return { 'value': form.key, 'label': form.label }
                                })}
                                className="react-select-custom forms__selector"
                                placeholder="Velg"
                            />

                        </div>
                    )}

                    {/* Default fields*/}

                    <div className="forms__formElement">
                        <Input name="firstName" placeholder="Fornavn/Firmanavn" validations="minLength:1" validationError="Fornavn er påkrevet" required/>
                    </div>
                    <div className="forms__formElement">
                        <Input name="lastName" placeholder="Etternavn" validations="minLength:1" validationError="Etternavn er påkrevet" required/>
                    </div>
                    <div className="forms__formElement">
                        <Input name="email" placeholder="Epost" validations="isEmail" validationError="Ugyldig epost" required/>
                    </div>
                    <div className="forms__formElement">
                        <Input name="phone" type="text" placeholder="Telefon" validations="minLength:1" required/>
                    </div>

                </div>
                {forms.filter(form => {
                    return form.key === this.state.selected
                }).map((form, i) => {
                    const SelectedForm = form.component;
                    return <SelectedForm hideHeaders={hideHeaders} ref={(childForm) => {
                        this.childForm = childForm
                    }} color={color}/>
                })}

              {termsPageUrl && (
                <div className="forms__termsContainer">
                  <a href={termsPageUrl}>Personvernerklæring</a>
                </div>
              )}

                {!this.state.canSubmit && (
                <div className="forms__notice forms__notice--error">
                    Du må fylle ut alle felter markert i rødt før du kan trykke "Send inn"
                </div>
                )}

                <button type="submit" className="forms__submit" disabled={!this.state.canSubmit}>Send inn</button>

                {error && (
                    <div className="forms__notice forms__notice--error">
                        Det skjedde en feil ved innsending av ditt skjema. Vennligst prøv igjen&hellip;
                    </div>
                )}
            </Formsy.Form>
        )
    }
}

module.exports = Forms;



// WEBPACK FOOTER //
// ./src/main/resources/site/parts/Forms/index.jsx